import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { TextField } from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { requestAxios } from "../../../util/util";
import AppContext from "../../../Context/AppContext";
import "./Referencias.css";

const Referencias = ({ acreditadoInfo }) => {
  const { checkUserSession, changeLoading } = useContext(AppContext);
  const [currentRow, setCurrentRow] = useState(acreditadoInfo);
   
  return (
    <div className="Referencias__container">
      <div className="Domicilios__btncontainer">
        <h1>Referencias Tels</h1>
      </div>
      <Form  >
        <br/>
        <h3>Referencia 1</h3>
        <div className="Referencia_containerItem">
          <TextField
            id="outlined-basic"
            label="A quien pertenece"
            variant="outlined"
            className="txtDireccionCalle"
            value={currentRow["AquienPertenece1"]}
            disabled
          />
          <TextField
            id="outlined-basic"
            label="Télefono"
            variant="outlined"
            className="txtDireccionCalle"
            value={currentRow["Otrotel1"]}
            disabled
          />
        </div>
        <br/>
        <h3>Referencia 2</h3>
        <div className="Referencia_containerItem">
          <TextField
            id="outlined-basic"
            label="A quien pertenece"
            variant="outlined"
            className="txtDireccionCalle"
            value={currentRow["Aquienpertenece2"]}
            disabled
          />
          <TextField
            id="outlined-basic"
            label="Télefono"
            variant="outlined"
            className="txtDireccionCalle"
            value={currentRow["OtroTel2"]}
            disabled
          />
        </div>
        <br />
      </Form>
    </div>
  );
};

export default Referencias;
